import { Heading } from "../../components";
import CaseStudyInfo from "../../components/CaseStudyInfo";
import React from "react";

const casesList = [
  {
    titleText: "How To Create Restaurant P&L Trend Analysis?",
    descriptionText:
      "A Profit and Loss Statement is one of the most important financial tools that a restaurant owner has to evaluate their operation in detail....",
    statsIconText: "50",
    downloadIconText: "50",
    priceText: "300 EGP",
  },
];

export default function CaseStudiesSection() {
  return (
    <>
      {/* case studies section */}
      <div className="flex flex-col gap-3.5">
        <div className="flex flex-col items-center">
          <div className="container-sm flex flex-col gap-2 lg:px-5 md:px-5">
            <div className="flex items-center justify-between gap-5">
              <Heading
                as="h1"
                className="sm:text-[18px] font-bold tracking-[0.15px] lg:text-[13px]"
              >
                Case Studies
              </Heading>
            </div>
            <div className="mr-[768px] flex gap-2 overflow-x-auto md:mr-0 md:flex-col sm:flex-row">
              {casesList.map((d, index) => (
                <CaseStudyInfo {...d} key={"listuserOne" + index} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
